// export interface RateEntry {
//     id: number
//     rating_score: number
// }
//
// export async function fetchRatingForItem(id: number){
//     const fetchOptions: RequestInit = {
//         method: "GET",
//         mode: 'cors',
//         cache: 'no-cache',
//         credentials: 'include',
//         redirect: 'manual',
//         headers: {
//             "Content-Type": "application/json"
//         }
//     };
//     return fetch(`/api/_v2/videos/${id}/me/rates/?sid=4561839008364728822`, fetchOptions)
//         .then((response) => {
//             if (response.status >= 400){
//                 return Promise.reject(response)
//             }
//             return response.json()
//         })
// }

export interface RateEntry {
    url: string
    rating: number
}

export async function fetchRatingForItem(id: string){
    const fetchOptions: RequestInit = {
        method: "GET",
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'include',
        redirect: 'manual',
        headers: {
            "Content-Type": "application/json"
        }
    };
    return fetch(`/account/rate/${id}/`, fetchOptions)
        .then((response) => {
            if (response.status >= 400){
                return Promise.reject(response)
            }
            return response.json()
        })
}

export async function bookmark(id: string, isNew: boolean){
    const url = `/account/${isNew ? "bookmark" : "unbookmark"}/${id}/`
    const fetchOptions: RequestInit = {
        method: 'GET',
        cache: 'no-cache',
        credentials: "include",
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
    }
    return fetch(url, fetchOptions)
        .then((response) => {
            if (response.status >= 400){
                return Promise.reject(response)
            }
            return response.text()
        })
}

export async function voteForFighter(matchId: number, fighterId: number){
    const fetchOptions: RequestInit = {
        method: "GET",
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'include',
        redirect: 'manual',
    };
    return fetch(`/account/vote/${matchId}/${fighterId}/`, fetchOptions)
        .then((response) => {
            if (response.status >= 400){
                return Promise.reject(response)
            }
            return response.text()
        })
}
